// Account Receivable Statements Mutations

export const updateStatementsList = (state, payload) => {
  state.statementsList = payload
}

export const updateStatementInfo = (state, payload) => {
  state.statementInfo = payload
}
